import { useEffect, useState } from "react";
import styled from "styled-components";
import DesktopPageHeader from "../../../../components/DesktopPageHeader";
import RankingDesktop from "../components/RankingDesktop";
import { OWNER_RANKING_TYPE, useOwnerRanking } from "../../../../hooks/useOwnerRanking";
import { useOwnerRestaurantSelection } from "../../../../hooks/useOwnerRestaurantSelection";

export const OwnerRankingPage = ({ resto }) => {
  const { getRanking, rankingData, loading, error } = useOwnerRanking();
  const [restoName, setRestoName] = useState("");
  const [avatar, setAvatar] = useState("");
  const [restoAddress, setRestoAddress] = useState("");
  const [restoId, setRestoId] = useState("");
  const { selectedOwnerRestaurantId, selectedOwnerRestaurant } = useOwnerRestaurantSelection();

  useEffect(() => {
    const selected = selectedOwnerRestaurant || resto;
    if (!selected) return;

    const selectedId = String(
      selectedOwnerRestaurantId || selected?._id || selected?.id || selected?.place_id || ""
    );
    setRestoId(selected?._id || selected?.id || selectedId);
    setRestoName(selected?.name || "");
    setRestoAddress(selected?.address || "");
    setAvatar(selected?.brand || "");
  }, [resto, selectedOwnerRestaurant, selectedOwnerRestaurantId]);

  useEffect(() => {
    if (!restoId) return;
    getRanking(restoId, OWNER_RANKING_TYPE.GLOBAL);
  }, [getRanking, restoId]);

  return (
    <>
      <PageContainer>
        <BannerWrap>
          <DesktopPageHeader img={avatar} alt={restoName} title={restoName} />
        </BannerWrap>
        <RankingDesktop
          data={rankingData?.ranking || []}
          total={rankingData?.total || 0}
          position={rankingData?.pos || 0}
          selectedCountry={OWNER_RANKING_TYPE.GLOBAL}
          hideCountrySelect
          loading={loading}
          error={error}
        />
      </PageContainer>
      <BottomSpacer />
    </>
  );
};

export default OwnerRankingPage;

const PageContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const BannerWrap = styled.div`
  @media (max-width: 1024px) {
    display: none;
  }
`;

const BottomSpacer = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    height: 100px;
  }
`;
